import './TeamPage.css';

class TeamPage {
  constructor(container) {
    this.container = container;
    
    // Image paths for each person
    this.joshImages = [
      '/assets/josh_cyberpunk.png',
      '/assets/josh_anime.png',
      '/assets/josh_80s_cyborg.png',
      '/assets/josh_hologram.png',
      '/assets/josh_pixel.png'
    ];
    
    this.grantImages = [
      '/assets/grant_cyberpunk.png',
      '/assets/grant_anime.png',
      '/assets/grant_80s_cyborg.png',
      '/assets/grant_hologram.png',
      '/assets/grant_pixel.png'
    ];
    
    // Currently selected image indices
    this.selectedJoshImageIndex = 0;
    this.selectedGrantImageIndex = 0;
  }
  
  /**
   * Render the team page
   */
  render() {
    this.container.innerHTML = `
      <div class="team-page">
        <table class="team-table">
          <tr>
            <th></th>
            <th data-person="josh"><a href="https://www.linkedin.com/in/joshgunning/" target="_blank" class="team-name-link">joshua-gunning.li</a></th>
            <th data-person="grant"><a href="https://www.linkedin.com/in/grant-demeter-a90865116/" target="_blank" class="team-name-link">grant-demeter.li</a></th>
          </tr>
          <tr>
            <td class="table-label">Looks like:</td>
            <td class="image-cell" data-person="josh">
              <div class="profile-image-container">
                <img src="${this.joshImages[this.selectedJoshImageIndex]}" alt="Josh Gunning" class="main-profile-image" id="josh-main-image">
                <div class="thumbnail-container">
                  ${this.joshImages.map((img, index) => `
                    <img src="${img}" alt="Josh Gunning ${index + 1}" 
                         class="thumbnail-image ${index === this.selectedJoshImageIndex ? 'selected' : ''}"
                         data-person="josh" data-index="${index}">
                  `).join('')}
                </div>
              </div>
            </td>
            <td class="image-cell" data-person="grant">
              <div class="profile-image-container">
                <img src="${this.grantImages[this.selectedGrantImageIndex]}" alt="Grant Demeter" class="main-profile-image" id="grant-main-image">
                <div class="thumbnail-container">
                  ${this.grantImages.map((img, index) => `
                    <img src="${img}" alt="Grant Demeter ${index + 1}" 
                         class="thumbnail-image ${index === this.selectedGrantImageIndex ? 'selected' : ''}"
                         data-person="grant" data-index="${index}">
                  `).join('')}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="table-label">Does:</td>
            <td data-person="josh">Co-founder, Product Brain</td>
            <td data-person="grant">Co-founder, Business Brain</td>
          </tr>
          <tr>
            <td class="table-label">Did:</td>
            <td data-person="josh">5x founder<br>(Assembly, +++)</td>
            <td data-person="grant">2x founder<br>(Morning Brew, +)</td>
          </tr>
          <tr>
            <td class="table-label">Also did:</td>
            <td data-person="josh">Senior Product leader<br>(Honey, Fetch, Clickup, +)</td>
            <td data-person="grant">15x investor in consumer/app startups<br>(Hallow, Quince, Music.ai, Volley, ++)</td>
          </tr>
          <tr>
            <td class="table-label">Credentialed:</td>
            <td data-person="josh">MFA No-Go & MBA Uh-Oh<br>"A generational mind in product" - Grant heard once</td>
            <td data-person="grant">Harvard MBA<br>"My son" - Grant's mom</td>
          </tr>
          <tr>
            <td class="table-label">Is giving:</td>
            <td data-person="josh">Pretty-nice (not to be confused with<br>pretty and nice) guy from the Midwest</td>
            <td data-person="grant">Nice guy from the midwest</td>
          </tr>
          <tr>
            <td class="table-label">Relationship status:</td>
            <td data-person="josh">Married to an awesome woman named Bri</td>
            <td data-person="grant">Married to an awesome woman named Sarah</td>
          </tr>
        </table>
      </div>
    `;
    
    this.setupEventListeners();
    
    return this;
  }
  
  /**
   * Set up event listeners for the thumbnail images
   */
  setupEventListeners() {
    const thumbnails = this.container.querySelectorAll('.thumbnail-image');
    
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => {
        const person = e.target.dataset.person;
        const index = parseInt(e.target.dataset.index, 10);
        
        if (person === 'josh') {
          this.selectedJoshImageIndex = index;
          // Update main image
          const mainImage = this.container.querySelector('#josh-main-image');
          mainImage.src = this.joshImages[index];
          
          // Update thumbnail selection
          const joshThumbnails = this.container.querySelectorAll('.thumbnail-image[data-person="josh"]');
          joshThumbnails.forEach((thumb, i) => {
            if (i === index) {
              thumb.classList.add('selected');
            } else {
              thumb.classList.remove('selected');
            }
          });
        } else if (person === 'grant') {
          this.selectedGrantImageIndex = index;
          // Update main image
          const mainImage = this.container.querySelector('#grant-main-image');
          mainImage.src = this.grantImages[index];
          
          // Update thumbnail selection
          const grantThumbnails = this.container.querySelectorAll('.thumbnail-image[data-person="grant"]');
          grantThumbnails.forEach((thumb, i) => {
            if (i === index) {
              thumb.classList.add('selected');
            } else {
              thumb.classList.remove('selected');
            }
          });
        }
      });
    });
  }
}

export default TeamPage; 